import { styled } from '@mui/material/styles';
import { useCopiloto } from 'src/contexts/copiloto-context';
import { ANCHO_COPILOTO } from 'src/components/copiloto/CopilotoDrawer';

/**
 * El lugar que el copiloto no reserva por su cuenta.
 *
 * El cajón es `persistent`: se apoya sobre la página en vez de correrla, así que
 * los 400 px de la derecha quedan abajo de un panel que igual se come los clicks.
 * Eso lo reservaba el layout del dashboard, y ahí estaba el agujero: 27 pantallas
 * no usan ese layout —`cajaProyecto`, `addMovimiento`, `solicitudes`— y en ellas
 * el botón de la derecha seguía sin responder. Migrarlas al layout del dashboard
 * les cambiaría el chrome entero por un bug de 400 px; el corrimiento sube a
 * `_app`, que es el único punto por el que pasan las 329.
 *
 * Que sea este div y no un `paddingRight` suelto: en `#__next` la cadena es
 * `html > body > #__next`, los tres `display: flex` en columna con `flex: 1 1
 * auto`. Un div pelado en el medio corta la cadena y las pantallas que pintan a
 * sangre —el login, el 404— dejan de estirarse hasta abajo: se encogen a lo que
 * mide su contenido y aparece la franja de fondo. Por eso acá se repite el molde
 * de `#__next` y la página sigue siendo un hijo de flex que estira.
 */
const Corrido = styled('div', {
  shouldForwardProp: (prop) => prop !== 'copiloto'
})(({ theme, copiloto }) => ({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  // De `md` para abajo el cajón toma la pantalla entera y no hay nada que
  // reservarle. Es el mismo corte que usa el `PaperProps` del cajón.
  [theme.breakpoints.up('md')]: {
    paddingRight: copiloto ? ANCHO_COPILOTO : 0,
    // Las duraciones son las del cajón, y las curvas también: si la página se
    // corre a otro ritmo que el panel, se ve un salto en el medio.
    transition: theme.transitions.create('padding-right', {
      easing: copiloto ? theme.transitions.easing.easeOut : theme.transitions.easing.sharp,
      duration: copiloto
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen
    })
  }
}));

export default function CorrimientoCopiloto({ children }) {
  const { abierto } = useCopiloto();

  return <Corrido copiloto={abierto ? 1 : 0}>{children}</Corrido>;
}
